export default __webpack_public_path__ + "static/media/wisdom-large.7b90d1fe.png";